import { baseTheme } from '@src/theme';
import { styled } from 'styled-components';

export const Container = styled.div`
    .prefix {
        display: flex;
        justify-content: center;
        align-items: center;
        width: 24px;
        height: 24px;
        border-radius: 4px;
        font-size: 12px;
        background-color: ${(props) =>
            props.theme?.colors?.secondary?.light?.surfaceBg ||
            baseTheme.colors.secondary.light.surfaceBg};
        color: ${(props) =>
            props.theme?.colors?.secondary?.main?.text ||
            baseTheme.colors.secondary.main.text};
    }

    .ant-color-picker-trigger {
        border: unset;
        box-shadow: unset;
    }

    .ant-color-picker-color-block {
        border-radius: 8px;
    }

    .ant-color-picker-panel {
        background-color: ${(props) =>
            props.theme?.colors?.secondary?.light?.contentBg ||
            baseTheme.colors.secondary.light.contentBg};
        border-color: ${(props) =>
            props.theme?.colors?.secondary?.light?.border ||
            baseTheme.colors.secondary.light.border};

        .ant-color-picker-slider-container {
            .ant-color-picker-slider-rail {
                background-color: ${(props) =>
                    props.theme?.colors?.secondary?.light?.surfaceBg ||
                    baseTheme.colors.secondary.light.surfaceBg};
            }

            .ant-color-picker-slider-handle {
                border-color: ${(props) =>
                    props.theme?.colors?.secondary?.light?.contentBg ||
                    baseTheme.colors.secondary.light.contentBg};
            }
        }
    }
`;
